import React from 'react';
import { Container, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import ProcessingHistory from '../components/ProcessingHistory';
import AppHeader from '../shared/components/AppHeader';

const TransactionHistory: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  if (!user) {
    navigate('/');
    return null;
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'grey.50' }}>
      <AppHeader />
      <Container maxWidth="xl" sx={{ py: 2, flex: 1 }}>
        <ProcessingHistory />
      </Container>
    </Box>
  );
};

export default TransactionHistory;